import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SidebarNavigationItemComponent } from './sidebar-navigation-item.component';
import { SidebarNavGroup } from './sidebar-navigation.models';

@Component({
  selector: 'app-sidebar-navigation-group',
  standalone: true,
  imports: [CommonModule, SidebarNavigationItemComponent],
  host: {
    class: 'block w-full',
  },
  template: `
    @if (group.separatorBefore) {
      <div [class]="separatorClass"></div>
    }

    @if (group.title) {
      <h3 [class]="titleClass">{{ group.title }}</h3>
    }

    <div [class]="itemsClass">
      @for (item of group.items; track item.id) {
        <div [class]="itemWrapperClass">
          <app-sidebar-navigation-item
            [item]="item"
            [variant]="variant"
            [active]="item.activeKey === currentSection"
            (itemClick)="itemSelected.emit(item.action)"
          ></app-sidebar-navigation-item>
        </div>
      }
    </div>
  `,
})
export class SidebarNavigationGroupComponent {
  @Input({ required: true }) group!: SidebarNavGroup;
  @Input({ required: true }) variant:
    | 'profile-settings'
    | 'profile-collapsed'
    | 'profile-sm'
    | 'profile-base'
    | 'backoffice-expanded'
    | 'backoffice-collapsed' = 'profile-settings';
  @Input() currentSection: string | null = null;
  @Input() separatorClass =
    'h-px bg-[var(--color-gray-300)]/30 dark:bg-[var(--color-white)]/10 my-4';
  @Input() titleClass =
    'text-sm text-[var(--color-gray-600)] dark:text-[var(--color-gray-400)] tracking-wider mb-2 px-3 sidebar-section-title';
  @Input() itemsClass = 'space-y-2';
  @Input() itemWrapperClass = '';

  @Output() readonly itemSelected = new EventEmitter<string>();
}
